import {
    BadgeDollarSign,
    Box,
    Boxes,
    PieChart, RotateCw,
    SettingsIcon,
    TableProperties,
    User
} from "lucide-vue-next";
import {type FunctionalComponent} from "vue";
import type { LucideProps } from "lucide-vue-next";
import { openDialog } from "./dialogs";

interface Route {
    title: string;
    route: string;
    icon: FunctionalComponent<LucideProps, {}, any, {}>;
    category: string;
    children?: {
        title: string;
        route: string;
        permission_required: string;
    }[];
    open?: {
        func: Function,
        dialogName: string,
        permission_required: string;
    }
    permission_required?: string;
}

const routes: Route[] = [
  {
    title: 'Orders',
    route: '/orders/:tab',
    icon: Boxes,
    category: "main",
    children: [
      { title: 'All', route: 'all', permission_required: "ORDERS_CATEGORY_VIEW_ALL" },
      { title: 'Incoming', route: 'incoming', permission_required: "ORDERS_CATEGORY_VIEW_INCOMING" },
      { title: 'Processing', route: 'processing', permission_required: "ORDERS_CATEGORY_VIEW_PROCESSING" },
      { title: 'Closed Out', route: 'completed', permission_required: "ORDERS_CATEGORY_VIEW_CLOSED_OUT" },
    ],
  },
  {
    title: 'Inventory',
    route: '/inventory/:tab',
    icon: Box,
    category: "main",
    children: [
      { title: 'All', route: 'all', permission_required: "INVENTORY_CATEGORY_VIEW_ALL" },
      { title: 'Active', route: 'active', permission_required: "INVENTORY_CATEGORY_VIEW_ACTIVE" },
      { title: 'Processing', route: 'processing', permission_required: "INVENTORY_CATEGORY_VIEW_PROCESSING" },
      { title: 'Sold', route: 'sold', permission_required: "INVENTORY_CATEGORY_VIEW_SOLD" },
      { title: 'Returns', route: 'returns', permission_required: "INVENTORY_CATEGORY_VIEW_RETURNS" },
      { title: 'Miscellaneous', route: 'miscellaneous', permission_required: "INVENTORY_CATEGORY_VIEW_MISCELLANEOUS" },
      { title: 'Unlisted', route: 'unlisted', permission_required: "INVENTORY_CATEGORY_VIEW_UNLISTED" },
    ],
  },
  {
    title: 'Sales',
    route: '/sales/:tab',
    icon: PieChart,
    category: "main",
    children: [
      { title: 'Soled', route: 'soled', permission_required: "SALES_CATEGORY_VIEW_SOLED" },
      { title: 'Miscellaneous', route: 'miscellaneous', permission_required: "SALES_CATEGORY_VIEW_MISCELLANEOUS" },
    ],
  },
  {
    title: 'Returns',
    route: '/returns/:tab',
    icon: PieChart,
    category: "main",
    children: [
      { title: 'Incoming', route: 'incoming', permission_required: "RETURNS_CATEGORY_VIEW_INCOMING" },
      { title: 'Received', route: 'received', permission_required: "RETURNS_CATEGORY_VIEW_RECEIVED" },
      { title: 'Returned', route: 'returned', permission_required: "RETURNS_CATEGORY_VIEW_RETURNED" },
    ],
  },
  { title: 'Users', route: '/users', icon: User, category: "main", permission_required: "USERS_CATEGORY_VIEW" },
  { title: 'Settings', route: '/settings', icon: SettingsIcon, category: "main", permission_required: "SETTINGS_CATEGORY_VIEW" },
  { title: 'Products', route: '/products', icon: Boxes, category: "main", permission_required: "PRODUCT_CATEGORY_VIEW" },
  {
      title: 'Bulk',
      route: '/bulk',
      icon: TableProperties,
      category: "tasks",
      open: {
          func: openDialog,
          dialogName: 'bulk',
          permission_required: "BULK_TRIGGER",
      },
      permission_required: "BULK_CATEGORY_VIEW"
  },
  {
      title: 'Repricing',
      route: '/repricing',
      icon: BadgeDollarSign,
      category: "tasks",
      open: {
          func: openDialog,
          dialogName: 'repricing',
          permission_required: "REPRICING_TRIGGER",
      },
      permission_required: "REPRICING_CATEGORY_VIEW"
  },
  {
      title: 'Syncing',
      route: '/syncing',
      icon: RotateCw,
      category: "tasks",
      open: {
          func: openDialog,
          dialogName: 'syncing',
          permission_required: "SYNCING_TRIGGER",
      },
      permission_required: "SYNCING_CATEGORY_VIEW"
  },
];

export { routes, type Route };